<template>
  <form @submit.prevent="onSubmit">
    <div class="space-y-8">
      <h6 class="text-gray-600">User Details</h6>

      <!--
        User First Name
      -->
      <ValidationProvider
        name="first name"
        vid="firstName"
        rules="required"
        v-slot="{ errors, failed }"
        slim
      >
        <BaseFormGroup class="w-full">
          <BaseFormLabel> First name * </BaseFormLabel>
          <BaseFormInput
            id="firstName"
            v-model="formData.firstName"
            :disabled="submitting"
            :invalid="failed"
            placeholder="enter first name..."
            v-select
          />
          <BaseFormInlineMessage v-if="failed" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </ValidationProvider>

      <!--
        User Last Name
      -->
      <ValidationProvider
        name="last name"
        vid="lastName"
        rules="required"
        v-slot="{ errors, failed }"
        slim
      >
        <BaseFormGroup class="w-full">
          <BaseFormLabel> Last name * </BaseFormLabel>
          <BaseFormInput
            id="lastName"
            v-model="formData.lastName"
            :disabled="submitting"
            :invalid="failed"
            placeholder="enter last name..."
          />
          <BaseFormInlineMessage v-if="failed" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </ValidationProvider>

      <!--
        User Name
      -->
      <ValidationProvider
        name="username"
        vid="username"
        rules="required"
        v-slot="{ errors, failed }"
        slim
      >
        <BaseFormGroup class="w-full">
          <BaseFormLabel> Username * </BaseFormLabel>
          <BaseFormInput
            id="username"
            v-model="formData.username"
            :disabled="submitting"
            :invalid="failed"
            placeholder="enter username..."
          />
          <BaseFormInlineMessage v-if="failed" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </ValidationProvider>
    </div>

    <div>
      <BaseButton type="submit" :disabled="submitting" class="btn btn-brand px-6">
        Update
      </BaseButton>
    </div>
  </form>
</template>

<script>
export default {
  name: 'GeneralForm',
  props: {
    submitting: Boolean,
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    username: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formData: {
        firstName: this.firstName,
        lastName: this.lastName,
        username: this.username,
      },
    };
  },
  watch: {
    firstName(val) {
      this.formData.firstName = val;
    },
    lastName(val) {
      this.formData.lastName = val;
    },
    username(val) {
      this.formData.username = val;
    },
  },
  methods: {
    onSubmit() {
      const diff = this.getDiff();
      if (Object.keys(diff).length) {
        this.$emit('submit', diff);
      }
    },
    getDiff() {
      const { formData, firstName, lastName, username } = this;
      const data = {
        ...(formData.firstName !== firstName ? { firstName: formData.firstName } : {}),
        ...(formData.lastName !== lastName ? { lastName: formData.lastName } : {}),
        ...(formData.username !== username ? { name: formData.username } : {}),
      };
      return data;
    },
  },
};
</script>
